import React, { useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';

import GlobalLoader from 'components/GlobalLoader';
import { useBasicHealthInfoQuery } from 'containers/Basics/graphql/queries/BasicHealthInfo/query';
import { HOUSEHOLD_PATH, INFO_PATH, SPOUSAL_PATH } from 'routes/constants';
import useSelector from 'store/useSelector';

import Info from './Info';

const Household = React.lazy(() => import(/* webpackChunkName: "household" */ './Household'));
const Spousal = React.lazy(() => import(/* webpackChunkName: "spousal" */ './Spousal'));

const Basics: React.FC = () => {
  const activeLifeApplicationId = useSelector((app) => app.activeLifeApplicationId);
  const activeUserUuid = useSelector((app) => app.activeUserUuid);

  const { data, loading } = useBasicHealthInfoQuery({
    variables: {
      uuid: activeUserUuid,
      lifeApplicationId: activeLifeApplicationId,
    },
  });

  const customer = data?.customer;
  const attributes = useMemo(
    () => JSON.parse(customer?.userAttributes ?? '{}'),
    [customer?.userAttributes]
  );

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <Routes>
      <Route
        path={HOUSEHOLD_PATH}
        element={
          <Household
            activeLifeApplicationId={activeLifeApplicationId}
            activeUserUuid={activeUserUuid}
            attributes={attributes}
            customer={customer}
            newPartnerReferral={data?.lifeApplication.newPartnerReferral}
          />
        }
      />
      <Route
        path={INFO_PATH}
        element={
          <Info
            activeLifeApplicationId={activeLifeApplicationId}
            activeUserUuid={activeUserUuid}
            customer={customer}
          />
        }
      />
      {/* MLD-1 - Remove if Life Spousal Self Serve loses - START */}
      <Route
        path={SPOUSAL_PATH}
        element={
          <Spousal activeUserUuid={activeUserUuid} customer={customer} attributes={attributes} />
        }
      />
      {/* MLD-1 - Remove if Life Spousal Self Serve loses - END */}
    </Routes>
  );
};

export default Basics;
